import { Image, Database, Search, MapPin, Shield, AlertCircle } from 'lucide-react';
import { MainBodyData, KeyTakeawaysData } from './types';

export const imintContent: MainBodyData = {
  number: '02',
  title: 'Image Intelligence (IMINT)',
  icon: Image,
  sections: {
    overview: "Image Intelligence (IMINT) focuses on extracting information from photographs and visual media. This includes reverse image searches, metadata extraction, geolocation, and facial recognition techniques.",
    note: "Always maintain original image files and metadata. Never alter source materials during investigation.",
    steps: [
      { title: "Image Acquisition", description: "Collect and preserve original image files with metadata intact" },
      { title: "Metadata Extraction", description: "Extract EXIF data, GPS coordinates, and camera information. (EXIF.tools, EXIF Viewer Pro [Chrome Extension], Jeffery's Image Metadata Viewer)" },
      { title: "Reverse Search", description: "Use multiple search engines to find image sources\n (Yandex, Bing, Google, Tineye)" },
      { title: "Geolocation Analysis", description: "Identify location using landmarks and environmental clues" }
    ],
    platforms: ["Google Images", "Yandex", "TinEye", "Bing Visual", "Baidu", "PimEyes"],
    dataPoints: [
      "EXIF metadata and GPS coordinates",
      "Camera make and model",
      "Date and time of capture",
      "Image resolution and format",
      "Digital signatures and hashes",
      "Reverse search results",
      "Use Yandex to translate text within images",
      "Use ExifTool CLI for advanced metadata extraction"
    ]
  }
};

export const imintTakeaways: KeyTakeawaysData = {
  sectionTitle: "IMINT",
  takeaways: [
    "Use multiple reverse image search engines for best results",
    "Preserve original EXIF data before any manipulation",
    "Verify geolocation with multiple reference points",
    "Consider sun angles and shadows for verification",
    "Check image forensics for manipulation signs",
    "Document all sources and methodologies"
  ],
  tools: [
    { name: "ExifTool", category: "METADATA", description: "Read, write and edit metadata in various files", url: "exiftool.org", icon: Database },
    { name: "Google Lens", category: "VISUAL SEARCH", description: "Powerful reverse image search and object ID", url: "lens.google.com", icon: Search },
    { name: "Yandex Images", category: "REVERSE SEARCH", description: "Often finds results missed by Google", url: "yandex.com/images", icon: Image },
    { name: "GeoSpy", category: "GEOLOCATION", description: "AI-powered location identification", url: "geospy.ai", icon: MapPin },
    { name: "InVID", category: "VERIFICATION", description: "Video and image verification toolkit", url: "invid-project.eu", icon: Shield },
    { name: "FotoForensics", category: "FORENSICS", description: "Detect image manipulation", url: "fotoforensics.com", icon: AlertCircle }
  ]
};